import { TokenProvider } from '@jds/react-engine';
export interface TabItemProps {
  appearance?: string;
  label: string;
  icon?: string;
  disabled?: boolean;
  onClick?: (index?: number) => void;
  children?: React.ReactNode;
  internalIndex?: number;
  activeTab?: number;
}

export const withLogic =
  (Component: React.ComponentType<TabItemProps>): React.FC<TabItemProps> =>
  (props: TabItemProps) => {
    return (
      <TokenProvider
        value={{ mode: props.appearance === 'tab_bar' ? 'dark' : undefined }}
      >
        <Component
          {...{
            ...props,
            onClick: () => {
              if (!props.disabled) {
                props.onClick?.(props.internalIndex);
              }
            },
            state:
              props.activeTab === props.internalIndex ? 'active' : 'default'
          }}
        />
      </TokenProvider>
    );
  };
